/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type PatientConsentStatus = typeof PatientConsentStatus[keyof typeof PatientConsentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientConsentStatus = {
  NotRequired: 'NotRequired',
  Pending: 'Pending',
  Given: 'Given',
} as const;
